var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAC2CB",
  fillRule: "evenodd",
  d: "M2 11C2 5.47 6.47 1 12 1s10 4.47 10 10-4.47 10-10 10S2 16.53 2 11m12.89 4.3c.39.39 1.02.39 1.41 0 .38-.39.38-1.03 0-1.41L13.41 11l2.89-2.89a.996.996 0 1 0-1.41-1.41L12 9.59 9.11 6.7A.996.996 0 1 0 7.7 8.11L10.59 11 7.7 13.89a.996.996 0 1 0 1.41 1.41L12 12.41z",
  clipRule: "evenodd"
})));
export { SvgCancel as ReactComponent };
export default __webpack_public_path__ + "Cancel.bd115aa2.svg";